import { Badge, Button, Group, Paper, Table, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useMySessions, useRevokeOtherSessions, useRevokeSession } from '@/api/account';
import { useCurrentWorkspace } from '@/app/WorkspaceContext';
import { useApiError } from '@/hooks/useApiError';
import { formatDate, inZone, timeFormat } from '@/lib/format';
import { describeAgent } from './agent';

/** Aktive Sitzungen anzeigen und abmelden (SEC-07). */
export function SessionsSection() {
  const { t } = useTranslation();
  const { prefs } = useCurrentWorkspace();
  const { data: sessions = [] } = useMySessions();
  const revoke = useRevokeSession();
  const revokeOthers = useRevokeOtherSessions();
  const onError = useApiError();
  const when = (v: string) => `${formatDate(inZone(v, prefs), prefs)} ${inZone(v, prefs).format(timeFormat(prefs))}`;
  return (
    <Paper withBorder p="md">
      <Group justify="space-between" mb="sm">
        <Title order={5}>{t('sessions.title')}</Title>
        {sessions.length > 1 && (
          <Button size="xs" variant="default" loading={revokeOthers.isPending} onClick={() => revokeOthers.mutate(undefined, { onError })}>
            {t('sessions.revokeOthers')}
          </Button>
        )}
      </Group>
      <Table.ScrollContainer minWidth={560}>
        <Table fz="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>{t('sessions.device')}</Table.Th>
              <Table.Th>{t('sessions.ip')}</Table.Th>
              <Table.Th>{t('sessions.lastActive')}</Table.Th>
              <Table.Th />
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {sessions.map((s) => (
              <Table.Tr key={s.id}>
                <Table.Td>
                  {describeAgent(s.userAgent)}{' '}
                  {s.current && (
                    <Badge size="xs" color="green" variant="light">
                      {t('sessions.current')}
                    </Badge>
                  )}
                </Table.Td>
                <Table.Td>{s.ip ?? '–'}</Table.Td>
                <Table.Td>
                  <Text size="sm">{when(s.lastAccessAt)}</Text>
                  <Text size="xs" c="dimmed">
                    {t('sessions.since', { date: when(s.createdAt) })}
                  </Text>
                </Table.Td>
                <Table.Td ta="right">
                  {!s.current && (
                    <Button size="compact-xs" variant="subtle" color="red" onClick={() => revoke.mutate(s.id, { onError })}>
                      {t('sessions.revoke')}
                    </Button>
                  )}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Paper>
  );
}
